import { useState, useContext, useEffect } from 'react';
import { diContainerContext } from 'application/contexts/useDiContainer';
import { IBilling } from 'domain/entities/Billing/Billing';
import { AgentBillingQuery } from 'interfaceAdapter/queries/AgentBilling';

export const useBilling = () => {
    const diContainer = useContext(diContainerContext);
    const agentBillingQuery = diContainer.resolve(AgentBillingQuery);
    const [billingList, setBillingList] = useState<IBilling[]>([]);

    useEffect(() => {
        const fetchData = async () => {
            const data = await agentBillingQuery.fetchList();
            setBillingList(data);
        };
        fetchData();
    }, []);

    return { billingList };
};
